import React from 'react';
import PropTypes from 'prop-types';
import './Skills.scss';

const rootClass = 'skills';

const Skills = ({ skills }) => {
	const skillElem = skills.map(((skill, idx) => {
		const precent = Number(skill.rating) * 10;
		return (
			<div className={`${rootClass}__info`} key={idx}>
				<div className={`${rootClass}__info__text`}>{skill.name}</div>
				<div className={`${rootClass}__info__rating`}>
					<div className="progress">
						<div className="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style={{width: `${precent}%`}}>
						</div>
					</div>
				</div>
			</div>
		);
	}));

	return (
		<div className={rootClass}>
			<h3 className={`${rootClass}__title`}>
				Skills
			</h3>
			<div className={`${rootClass}__desc`}>
				{skillElem}
			</div>
		</div>
	);
};

Skills.propTypes = {
	skills: PropTypes.array,
};

export default Skills;